export default class PopOverStyle {

	/**
	 * @param position PopOver.POSITION... position of this style
	 * @param popupTop
	 * @param popupLeft
	 * @param arrowTop
	 * @param arrowLeft
	 */
	constructor(position, popupTop, popupLeft, arrowTop, arrowLeft) {
		this.position = position;

		this.popupStyle = {
			top: `${popupTop}px`,
			left: `${popupLeft}px`,
		};

		this.arrowStyle = {
			top: `${arrowTop}px`,
			left: `${arrowLeft}px`,
		};
	}
}
